import { SelectedFilters } from "@cruisen/react-shared"
import { load, save } from "../../../utils/storage"

export type CruisePreferenceStorage = {
  searchCriteriaHash: string
  filters: SelectedFilters
  sortingOption: string
  updatedAt: number
}

const getSavedPrefence = (tripId: string, searchCriteriaHash: string) => {
  if (!tripId || !searchCriteriaHash) return null

  const loadedData = load<CruisePreferenceStorage>(`cruisePreferences-${tripId}`)

  if (loadedData?.searchCriteriaHash !== searchCriteriaHash) return null

  return loadedData
}

export const useSaveCruisePreferences = ({
  tripId,
  searchCriteriaHash,
}: {
  tripId: string
  searchCriteriaHash: string
}) => {
  const savedCruisePreferences = getSavedPrefence(tripId, searchCriteriaHash)

  const saveCruisePreferences = ({
    filters,
    sortingOption,
  }: {
    filters: SelectedFilters
    sortingOption: string
  }) => {
    save(`cruisePreferences-${tripId}`, {
      updatedAt: new Date().valueOf(),
      searchCriteriaHash,
      filters,
      sortingOption,
    })
  }

  return { savedCruisePreferences, saveCruisePreferences }
}
